// import React, { useRef, useState } from 'react'
// import { Link } from 'react-router-dom'
// import CaptainDetails from '../components/CaptainDetails'
// import RidePopUp from '../components/RidePopUp'
// import { useGSAP } from '@gsap/react'
// import gsap from 'gsap'
// import ConfirmRidePopUp from '../components/ConfirmRidePopUp'
// import { useEffect, useContext } from 'react'
// import { SocketContext } from '../context/SocketContext'
// import { CaptainDataContext } from "../context/CaptainContext";
// import axios from 'axios'

// const CaptainHome = () => {

//     const [ridePopupPanel, setRidePopupPanel] = useState(false)
//     const [confirmRidePopupPanel, setConfirmRidePopupPanel] = useState(false)

//     const ridePopupPanelRef = useRef(null)
//     const confirmRidePopupPanelRef = useRef(null)
//     const [ride, setRide] = useState(null)

//     const { socket } = useContext(SocketContext)
//     const { captain } = useContext(CaptainDataContext)

//     useEffect(() => {
//         if (!captain?._id || !socket) return;

//         // console.log('🚗 Captain ID:', captain._id);

//         // Join socket room
//         socket.emit('join', {
//             userId: captain._id,
//             userType: 'captain'
//         });
//         // console.log('📡 Join event emitted for captain');

//         // Listen for new ride
//         socket.on('new-ride', (data) => {
//             // console.log('🎉 NEW RIDE RECEIVED!', data);
//             // console.log('✅ Setting ride state and showing popup');
//             setRide(data);
//             setRidePopupPanel(true);
//             console.log("force open popup");
//             if (ridePopupPanelRef.current) {
//                 gsap.to(ridePopupPanelRef.current, {
//                     transform: 'translateY(0)'
//                 })
//             }

//             // TEST: Force show alert to confirm popup should appear
//             alert('🎉 New ride received! Check for popup.');
//             alert("You have received a new ride request. Click OK to review the details and confirm the ride.");

//         });

//         // Test listener
//         socket.on('test-ride', (data) => {
//             // console.log('🧪 Test ride received:', data);
//             alert('Test notification: ' + data.message);
//         });

//         const updateLocation = () => {
//             if (navigator.geolocation) {
//                 navigator.geolocation.getCurrentPosition(position => {
//                     // console.log('📍 Position updated:', position.coords.latitude, position.coords.longitude);

//                     socket.emit('update-location-captain', {
//                         userId: captain._id,
//                         location: {
//                             ltd: position.coords.latitude,
//                             lng: position.coords.longitude
//                         }
//                     })
//                 })
//             }
//         }

//         const locationInterval = setInterval(updateLocation, 10000)
//         updateLocation()

//         return () => {
//             clearInterval(locationInterval);
//             socket.off('new-ride');
//             socket.off('test-ride');
//         }
//     }, [captain, socket])

//     useEffect(() => {
//         // console.log('🔍 ridePopupPanel changed to:', ridePopupPanel);
//         // console.log('🔍 Current ride:', ride);
//     }, [ridePopupPanel, ride]);

//     async function confirmRide() {
//         // console.log('Confirming ride:', ride?._id);

//         const token = localStorage.getItem('token') || localStorage.getItem('token');

//         try {
//             const response = await axios.post(`${import.meta.env.VITE_BASE_URL}/rides/confirm`, {
//                 rideId: ride._id
//             }, {
//                 headers: {
//                     Authorization: `Bearer ${token}`
//                 }
//             })

//             // console.log('✅ Ride confirmed:', response.data);
//             setRidePopupPanel(false);
//             setConfirmRidePopupPanel(true);
//         } catch (error) {
//             // console.error('❌ Error confirming ride:', error);
//             alert('Failed to confirm ride: ' + (error.response?.data?.message || error.message));
//         }
//     }


//     useGSAP(function () {
//         console.log('🎬 GSAP animation triggered for ridePopupPanel:', ridePopupPanel);

//         if (ridePopupPanel) {
//             gsap.to(ridePopupPanelRef.current, {
//                 transform: 'translateY(0)',
//                 duration: 0.3,
//                 ease: "power2.out"
//             });
//         } else {
//             gsap.to(ridePopupPanelRef.current, {
//                 transform: 'translateY(100%)',
//                 duration: 0.3,
//                 ease: "power2.in"
//             });
//         }
//     }, [ridePopupPanel])

//     useGSAP(function () {
//         console.log('🎬 GSAP animation triggered for confirmRidePopupPanel:', confirmRidePopupPanel);

//         if (confirmRidePopupPanel) {
//             gsap.to(confirmRidePopupPanelRef.current, {
//                 transform: 'translateY(0)',
//                 duration: 0.3,
//                 ease: "power2.out"
//             });
//         } else {
//             gsap.to(confirmRidePopupPanelRef.current, {
//                 transform: 'translateY(100%)',
//                 duration: 0.3,
//                 ease: "power2.in"
//             });
//         }
//     }, [confirmRidePopupPanel])

//     return (
//         <div className='h-screen relative'>
//             <div className='fixed p-6 top-0 flex items-center justify-between w-screen z-20'>
//                 <img className='w-16' src="https://upload.wikimedia.org/wikipedia/commons/c/cc/Uber_logo_2018.png" alt="" />
//                 <Link to='/captain-home' className=' h-10 w-10 bg-white flex items-center justify-center rounded-full'>
//                     <i className="text-lg font-medium ri-logout-box-r-line"></i>
//                 </Link>
//             </div>
//             <div className='h-3/5'>
//                 <img className='h-full w-full object-cover' src="https://miro.medium.com/v2/resize:fit:1400/0*gwMx05pqII5hbfmX.gif" alt="" />
//             </div>
//             <div className='h-2/5 p-6'>
//                 <CaptainDetails />
//             </div>

//             {/* Ride Popup - Fixed styling */}
//             <div
//                 ref={ridePopupPanelRef}
//                 className='fixed w-full z-30 bottom-0 translate-y-full bg-white px-3 py-10 pt-12 rounded-t-3xl shadow-2xl'
//                 style={{
//                     maxHeight: '80vh',
//                     overflowY: 'auto'
//                 }}
//             >
//                 {ride ? (
//                     <RidePopUp
//                         ride={ride}
//                         setRidePopupPanel={setRidePopupPanel}
//                         setConfirmRidePopupPanel={setConfirmRidePopupPanel}
//                         confirmRide={confirmRide}
//                     />
//                 ) : (
//                     <div className="text-center p-10">
//                         <p>Loading ride details...</p>
//                     </div>
//                 )}
//             </div>

//             {/* Confirm Ride Popup */}
//             <div
//                 ref={confirmRidePopupPanelRef}
//                 className='fixed w-full h-screen z-30 bottom-0 translate-y-full bg-white px-3 py-10 pt-12'
//             >
//                 {ride ? (
//                     <ConfirmRidePopUp
//                         ride={ride}
//                         setConfirmRidePopupPanel={setConfirmRidePopupPanel}
//                         setRidePopupPanel={setRidePopupPanel}
//                     />
//                 ) : (
//                     <div className="text-center p-10">
//                         <p>Loading ride details...</p>
//                     </div>
//                 )}
//             </div>

//             {/* Debug overlay - shows when popup should be visible */}
//             {ridePopupPanel && (
//                 <div className="fixed inset-0 bg-black bg-opacity-30 z-20"
//                     onClick={() => setRidePopupPanel(false)}>
//                     <div className="absolute top-4 left-4 bg-red-500 text-white p-2 rounded">
//                         Popup Active - Click to close
//                     </div>
//                 </div>
//             )}
//         </div>
//     )
// }

// export default CaptainHome



import React, { useState, useEffect, useContext } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import CaptainDetails from '../components/CaptainDetails'
import { SocketContext } from '../context/SocketContext'
import { CaptainDataContext } from "../context/CaptainContext";
import axios from 'axios'

const CaptainHome = () => {

    const [showRidePopup, setShowRidePopup] = useState(false)
    const [showConfirmPopup, setShowConfirmPopup] = useState(false)
    const [ride, setRide] = useState(null)
    const [isLoading, setIsLoading] = useState(false)

    const navigate = useNavigate()
    const { socket } = useContext(SocketContext)
    const { captain } = useContext(CaptainDataContext)

    useEffect(() => {
        if (!socket || !captain?._id) return

        socket.emit('join', {
            userId: captain._id,
            userType: 'captain'
        })

        socket.on('new-ride', (data) => {
            if (data && data._id) {
                setRide(data)
                setShowRidePopup(true)
            }
        })

        return () => {
            socket.off('new-ride')
        }
    }, [socket, captain?._id])

    async function acceptRide() {
        if (!ride?._id) return

        setIsLoading(true)
        const token = localStorage.getItem('token')

        try {
            const response = await axios.post(
                `${import.meta.env.VITE_BASE_URL}/rides/confirm`,
                { rideId: ride._id },
                { headers: { Authorization: `Bearer ${token}` } }
            )

            setShowRidePopup(false)
            setTimeout(() => setShowConfirmPopup(true), 200)
        } catch (error) {
            console.error('Error:', error)
            alert('Failed to accept ride')
        } finally {
            setIsLoading(false)
        }
    }

    async function startRide() {
        const otp = document.getElementById('otp-input')?.value
        if (!otp) {
            alert('Please enter OTP')
            return
        }

        if (!ride?._id) {
            alert('No ride found')
            return
        }

        const token = localStorage.getItem('token')

        try {
            const response = await axios.get(
                `${import.meta.env.VITE_BASE_URL}/rides/start-ride`,
                {
                    params: {
                        rideId: ride._id,
                        otp: otp
                    },
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            )

            alert('Ride started successfully!')
            setShowConfirmPopup(false)
            navigate('/captain-riding', { state: { ride: response.data } })

        } catch (error) {
            console.error('Error starting ride:', error)
            alert('Failed to start ride: ' + (error.response?.data?.message || error.message))
        }
    }

    const popupStyle = {
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 30,
        backgroundColor: 'white',
        padding: '1.5rem 0.75rem 1.5rem 0.75rem',
        paddingTop: '3rem',
        borderRadius: '1.5rem 1.5rem 0 0',
        boxShadow: '0 -4px 6px -1px rgba(0, 0, 0, 0.1)',
        transition: 'transform 0.3s ease-out'
    }

    return (
        <div style={{ height: '100vh', position: 'relative', overflow: 'hidden' }}>
            {/* Header */}
            <div style={{ position: 'fixed', padding: '1.5rem', top: 0, left: 0, right: 0, display: 'flex', alignItems: 'center', justifyContent: 'space-between', zIndex: 20 }}>
                <img style={{ width: '4rem' }} src="https://upload.wikimedia.org/wikipedia/commons/c/cc/Uber_logo_2018.png" alt="Uber" />
                <Link to='/captain/logout' style={{ height: '2.5rem', width: '2.5rem', backgroundColor: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '9999px', boxShadow: '0 1px 3px 0 rgba(0,0,0,0.1)' }}>
                    <i className="text-lg font-medium ri-logout-box-r-line"></i>
                </Link>
            </div>

            {/* Map Image */}
            <div style={{ height: '60%' }}>
                <img style={{ height: '100%', width: '100%', objectFit: 'cover' }} src="https://miro.medium.com/v2/resize:fit:1400/0*gwMx05pqII5hbfmX.gif" alt="Map" />
            </div>

            {/* Captain Details */}
            <div style={{ height: '40%', padding: '1.5rem' }}>
                <CaptainDetails />
            </div>

            {/* Ride Request Popup */}
            {showRidePopup && ride && (
                <div style={popupStyle}>
                    <h5 style={{ padding: '0.25rem', textAlign: 'center', width: '100%', position: 'absolute', top: '0.5rem', left: 0, cursor: 'pointer' }} onClick={() => setShowRidePopup(false)}>
                        <i className="text-3xl text-gray-400 ri-arrow-down-wide-line"></i>
                    </h5>
                    <h3 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '1.25rem', textAlign: 'center' }}>New Ride Available!</h3>

                    <div style={{ width: '100%' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '1.25rem', padding: '0.75rem', borderBottom: '1px solid #e5e7eb' }}>
                            <i className="ri-user-fill text-xl"></i>
                            <div>
                                <h3 style={{ fontSize: '1.125rem', fontWeight: '500' }}>
                                    {ride?.user?.fullname?.firstname || 'Unknown'} {ride?.user?.fullname?.lastname || ''}
                                </h3>
                                <p style={{ fontSize: '0.875rem', color: '#6b7280' }}>Passenger</p>
                            </div>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '1.25rem', padding: '0.75rem', borderBottom: '1px solid #e5e7eb' }}>
                            <i className="ri-map-pin-user-fill text-xl"></i>
                            <div>
                                <h3 style={{ fontSize: '1.125rem', fontWeight: '500' }}>Pickup</h3>
                                <p style={{ fontSize: '0.875rem', color: '#6b7280' }}>{ride?.pickup}</p>
                            </div>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '1.25rem', padding: '0.75rem', borderBottom: '1px solid #e5e7eb' }}>
                            <i className="ri-map-pin-2-fill text-xl"></i>
                            <div>
                                <h3 style={{ fontSize: '1.125rem', fontWeight: '500' }}>Destination</h3>
                                <p style={{ fontSize: '0.875rem', color: '#6b7280' }}>{ride?.destination}</p>
                            </div>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '1.25rem', padding: '0.75rem', borderBottom: '1px solid #e5e7eb', backgroundColor: '#fef3c7' }}>
                            <i className="ri-key-2-line text-xl text-yellow-600"></i>
                            <div>
                                <h3 style={{ fontSize: '1.125rem', fontWeight: '500', color: '#92400e' }}>OTP</h3>
                                <p style={{ fontSize: '1.25rem', fontWeight: 'bold', color: '#dc2626' }}>{ride?.otp || 'Loading...'}</p>
                            </div>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '1.25rem', padding: '0.75rem' }}>
                            <i className="ri-currency-line text-xl"></i>
                            <div>
                                <h3 style={{ fontSize: '1.125rem', fontWeight: '500' }}>₹{ride?.fare}</h3>
                                <p style={{ fontSize: '0.875rem', color: '#6b7280' }}>Cash</p>
                            </div>
                        </div>
                    </div>

                    <button
                        onClick={acceptRide}
                        disabled={isLoading}
                        style={{
                            width: '100%',
                            marginTop: '1.5rem',
                            backgroundColor: isLoading ? '#9ca3af' : '#16a34a',
                            color: 'white',
                            fontWeight: '600',
                            padding: '0.875rem',
                            borderRadius: '0.5rem',
                            border: 'none',
                            cursor: isLoading ? 'not-allowed' : 'pointer',
                            fontSize: '1rem'
                        }}
                    >
                        {isLoading ? 'Accepting...' : 'Accept Ride'}
                    </button>
                </div>
            )}

            {/* Confirm Ride Popup */}
            {showConfirmPopup && ride && (
                <div style={popupStyle}>
                    <h5 style={{ padding: '0.25rem', textAlign: 'center', width: '100%', position: 'absolute', top: '0.5rem', left: 0, cursor: 'pointer' }} onClick={() => setShowConfirmPopup(false)}>
                        <i className="text-3xl text-gray-400 ri-arrow-down-wide-line"></i>
                    </h5>
                    <h3 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '1.25rem', textAlign: 'center' }}>Confirm to Start</h3>

                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0.75rem', border: '2px solid #fbbf24', borderRadius: '0.5rem', marginBottom: '1rem' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                            <div style={{ height: '3rem', width: '3rem', borderRadius: '9999px', backgroundColor: '#f59e0b', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <i className="ri-user-fill text-white text-xl"></i>
                            </div>
                            <h2 style={{ fontSize: '1.125rem', fontWeight: '500' }}>{ride?.user?.fullname?.firstname}</h2>
                        </div>
                        <h5 style={{ fontSize: '1.125rem', fontWeight: '600' }}>2.2 KM</h5>
                    </div>

                    <div style={{ width: '100%' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '1.25rem', padding: '0.75rem', borderBottom: '1px solid #e5e7eb' }}>
                            <i className="ri-map-pin-user-fill text-xl"></i>
                            <div>
                                <h3 style={{ fontSize: '1rem', fontWeight: '500' }}>{ride?.pickup}</h3>
                                <p style={{ fontSize: '0.75rem', color: '#6b7280' }}>Pickup Location</p>
                            </div>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '1.25rem', padding: '0.75rem', borderBottom: '1px solid #e5e7eb' }}>
                            <i className="ri-map-pin-2-fill text-xl"></i>
                            <div>
                                <h3 style={{ fontSize: '1rem', fontWeight: '500' }}>{ride?.destination}</h3>
                                <p style={{ fontSize: '0.75rem', color: '#6b7280' }}>Destination</p>
                            </div>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '1.25rem', padding: '0.75rem', borderBottom: '1px solid #e5e7eb', backgroundColor: '#fef3c7' }}>
                            <i className="ri-key-2-line text-xl text-yellow-600"></i>
                            <div>
                                <h3 style={{ fontSize: '1rem', fontWeight: '500', color: '#92400e' }}>OTP Required</h3>
                                <p style={{ fontSize: '0.875rem', color: '#dc2626', fontWeight: 'bold' }}>Enter the OTP shown to user</p>
                            </div>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '1.25rem', padding: '0.75rem' }}>
                            <i className="ri-currency-line text-xl"></i>
                            <div>
                                <h3 style={{ fontSize: '1rem', fontWeight: '500' }}>₹{ride?.fare}</h3>
                                <p style={{ fontSize: '0.75rem', color: '#6b7280' }}>Cash</p>
                            </div>
                        </div>
                    </div>

                    <input
                        type="text"
                        placeholder="Enter OTP"
                        id="otp-input"
                        style={{
                            width: '100%',
                            padding: '1rem',
                            backgroundColor: '#f3f4f6',
                            border: 'none',
                            borderRadius: '0.5rem',
                            marginTop: '1rem',
                            fontSize: '1rem',
                            textAlign: 'center',
                            letterSpacing: '4px'
                        }}
                    />

                    <button
                        onClick={startRide}
                        style={{
                            width: '100%',
                            marginTop: '1rem',
                            backgroundColor: '#16a34a',
                            color: 'white',
                            fontWeight: '600',
                            padding: '0.875rem',
                            borderRadius: '0.5rem',
                            border: 'none',
                            cursor: 'pointer'
                        }}
                    >
                        Start Ride
                    </button>

                    <button
                        onClick={() => setShowConfirmPopup(false)}
                        style={{
                            width: '100%',
                            marginTop: '0.5rem',
                            backgroundColor: '#dc2626',
                            color: 'white',
                            fontWeight: '600',
                            padding: '0.875rem',
                            borderRadius: '0.5rem',
                            border: 'none',
                            cursor: 'pointer'
                        }}
                    >
                        Cancel
                    </button>
                </div>
            )}
        </div>
    )
}

export default CaptainHome